import request from '@/utils/request'

//2，公司简介、董事长寄语、发展历程接口 1企业简介 2董事长寄语 3发展历程  cn中文 en英文 ru俄文
export function getstaticcontent(lang, params) {
    return request({
        url: `/${lang}/wms/dqgx/getstaticcontent/${params}`,
        method: 'get'
    })
}

//3，相册图集接口  1员工风采 2公司奖章
export function getpiclist(lang, params) {
    return request({
        url: `/${lang}/wms/dqgx/getpiclist/${params}`,
        method: 'get'
    })
}